<template>
  <div class="container">
    <!-- Enter Promotion Name -->
    <div class="form-row">
      <div class="form-group full">
        <label>Promotion Name <span>*</span></label>
        <input type="text" v-model="promotion.name" placeholder="Enter promotion name"/>
      </div>
    </div>

    <!-- Enter Promotion Code and Promotion Type Selection -->
    <div class="form-row">
      <div class="form-group half">
        <label>Promotion Code <span>*</span></label>
        <input type="text" v-model="promotion.code" placeholder="Enter promotion code" />
      </div>

      <div class="form-group half">
        <label>Promotion Type <span>*</span></label>
        <select v-model="promotion.type">
          <option disabled value="">Select Promotion Type</option>
          <option value="Free Issue">Free Issue</option>
          <option value="Discount">Discount</option>
          <option value="Competitor Price Discount">Competitor Price Discount</option>
          <option value="Trust">Trust</option>
        </select>
      </div>
    </div>

    <!-- Pick Promotion Start Date & Promotion End Date -->
    <div class="form-row">
      <div class="form-group half">
        <label>Start Date <span>*</span></label>
        <input type="date" v-model="promotion.startDate" :min="today"/>
      </div>

      <div class="form-group half">
        <label>End Date <span>*</span></label>
        <input type="date" v-model="promotion.endDate" :min="promotion.startDate || today"/>
      </div>
    </div>

    <!-- Item Promotion Setup -->
    <div class="promotion-item-setup">
      <b>Item Promotion Setup</b>

      <!-- Promotion Type Not Selected UI -->
      <div v-if="promotion.type === ''" class="promo-box warning">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <p>Select promotion type to add promotion items</p>
      </div>

      <!-- Free Issue UI -->
      <div v-if="promotion.type === 'Free Issue'" class="promo-box">
        <div class="form-row">
          <div class="form-group half">
            <label>Buy Item <span>*</span></label>
            <select v-model="promotion.freeIssue.getItem">
              <option disabled value="">Select Item</option>
              <option v-for="item in filteredItems" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="form-group narrow">
            <label>Buy Qty <span>*</span></label>
            <input type="number" v-model="promotion.freeIssue.getQty" />
          </div>

          <div class="form-group half">
            <label>Free Item <span>*</span></label>
            <select v-model="promotion.freeIssue.freeItem">
              <option disabled value="">Select Item</option>
              <option v-for="item in filteredItems" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="form-group narrow">
            <label>Free Qty <span>*</span></label>
            <input type="number" v-model="promotion.freeIssue.freeQty" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group half">
            <label>Maximum Applicable Free Qty <span>*</span></label>
            <input type="number" v-model="promotion.freeIssue.maxQty" />
            <small>Maximum quantity of applicable this promotion.</small>
          </div>
        </div>
      </div>

      <!-- Discount UI -->
      <div v-if="promotion.type === 'Discount'" class="promo-box">
        <!-- First Row: Item + % + Rs -->
        <div class="form-row">
          <div class="form-group half">
            <label>Item <span>*</span></label>
            <select v-model="promotion.discount.item">
              <option disabled value="">Select Item</option>
              <option v-for="item in filteredItems" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="form-group narrow">
            <label>Discount Type <span>*</span></label>
            <select v-model="promotion.discount.type">
              <option disabled value="">Select Discount Type</option>
              <option value="percentage">Percentage</option>
              <option value="value">Value</option>
            </select>
          </div>
          <div class="form-group narrow">
            <label>Discount <span>*</span></label>
            <input type="number" v-model="promotion.discount.discount" />
          </div>
        </div>

        <!-- Second Row: Min + Max -->
        <div class="form-row">
          <div class="form-group half">
            <label>Minimum Required Buy Qty <span>*</span></label>
            <input type="number" v-model="promotion.discount.minQty" />
            <small>Minimum quantity to qualify for discount.</small>
          </div>
          <div class="form-group half">
            <label>Maximum Applicable Free Qty <span>*</span></label>
            <input type="number" v-model="promotion.discount.maxQty" />
            <small>Maximum quantity to qualify for discount.</small>
          </div>
        </div>
      </div>

      <!-- Competitor Price Discount UI -->
      <div v-if="promotion.type === 'Competitor Price Discount'" class="promo-box">
          <div class="form-row">
            <div class="form-group half">
              <label>Item <span>*</span></label>
              <select v-model="promotion.discount.item">
                <option disabled value="">Select Item</option>
                <option v-for="item in filteredItems" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <div class="form-group narrow">
              <label>Discount Type <span>*</span></label>
              <select v-model="promotion.discount.type" disabled>
                <option disabled value="">Select Discount Type</option>
                <option value="percentage">Percentage</option>
                <option value="value">Value</option>
              </select>
            </div>
            <div class="form-group narrow">
              <label>Discount <span>*</span></label>
              <input type="number" v-model="promotion.discount.discount" />
            </div>
        </div>
      </div>

      <!-- Trust UI -->
      <div v-if="promotion.type === 'Trust'" class="promo-box">
          <div class="form-row">
            <div class="form-group half">
              <label>Item <span>*</span></label>
              <select v-model="promotion.discount.item">
                <option disabled value="">Select Item</option>
                <option v-for="item in filteredItems" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>
            <div class="form-group narrow">
              <label>Discount Type <span>*</span></label>
              <input type="text" value="Quantity" disabled />
            </div>
            <div class="form-group narrow">
              <label>Maximum quantity <span>*</span></label>
              <input type="number" v-model="promotion.discount.discount" />
            </div>
        </div>
      </div>
    </div>

    <!-- Select Promotion Applicable Dealers -->
    <div class="dealer-selection-section">
      <div class="dealer-header">
        <b>Promotion Applicable Dealers <span>*</span></b>
        <small v-if="promotion.selectedDealers.length > 0" class="dealer-count">No of Dealers: {{ promotion.selectedDealers.length }}</small>
      </div>

      <!-- Dealer Loading Indicator -->
      <div v-if="loadingDealers" style="text-align: center; padding: 20px;">
        <i class="fa fa-spinner fa-spin"></i> Loading dealers...
      </div>

      <template v-else>
      <!-- Dealer Search -->
      <div class="form-row search-container">
        <!-- Toggle Button -->
        <button
            type="button"
            class="dealer-toggle-btn"
            :class="promotion.selectedDealers.length > 0 ? 'remove-btn' : 'apply-btn'"
            @click="toggleDealers"
        >
          {{ promotion.selectedDealers.length > 0 ? 'Remove All' : 'Apply for All' }}
        </button>

        <input
            type="text"
            v-model="dealerSearch"
            placeholder="Search dealers by name..."
            class="search-box"
        />
      </div>

      <!-- Tab Buttons -->
      <div class="dealer-tabs">
        <button type="button" :class="{ active: activeTab === 'all' }" @click="activeTab = 'all'">All</button>
        <button type="button" :class="{ active: activeTab === 'route' }" @click="activeTab = 'route'">Filter by Route</button>
        <button type="button" :class="{ active: activeTab === 'group' }" @click="activeTab = 'group'">Filter by Group</button>
        <button type="button" :class="{ active: activeTab === 'category' }" @click="activeTab = 'category'">Filter by Category</button>
      </div>

      <!-- Tab Content: All -->
      <div v-if="activeTab === 'all'" class="tab-content">
        <div class="dealer-cards">
           <div v-for="dealer in filteredAllDealers" :key="dealer.profileId" 
                class="dealer-card" 
                :class="{ selected: isDealerSelected(dealer) }"
                @click="toggleDealerSelection(dealer)">
               <strong>{{ dealer.businessName }}</strong><br>
               <small>Address: {{ dealer.address }}</small><br>
               <i v-if="isDealerSelected(dealer)" class="fa-solid fa-check-circle check-icon"></i>
           </div>
        </div>
      </div>

      <!-- Tab Content: Filter by Route -->
      <div v-if="activeTab === 'route'" class="tab-content">
         <div v-for="(dealersInRoute, route) in dealersByRoute" :key="route" class="dealer-group">
            <div class="group-header" @click="toggleCollapse('route', route)">
               <span>
                 {{ route || 'Unassigned' }}
                 <small style="font-weight: normal; margin-left: 10px; color: #555;">
                   Total Dealer Count: {{ dealersInRoute.length }} | Selected Dealer Count: {{ getSelectedCount(dealersInRoute) }}
                 </small>
               </span>
               <div class="accordion-actions">
                 <button 
                   class="apply-all-btn" 
                   :class="{ 'remove-btn': getSelectedCount(dealersInRoute) > 0 }"
                   @click.stop="toggleAllDealers(dealersInRoute)">
                   {{ getSelectedCount(dealersInRoute) > 0 ? 'Remove All' : 'Apply All' }}
                 </button>
                 <i :class="getCollapseIcon('route', route)"></i>
               </div>
            </div>
            <div class="group-body" v-show="!isCollapsed('route', route)">
               <div class="dealer-cards">
                 <div v-for="dealer in dealersInRoute" :key="dealer.profileId" 
                      class="dealer-card" 
                      :class="{ selected: isDealerSelected(dealer) }"
                      @click="toggleDealerSelection(dealer)">
                     <strong>{{ dealer.businessName }}</strong><br>
                     <small>Address: {{ dealer.address }}</small><br>
                     <i v-if="isDealerSelected(dealer)" class="fa-solid fa-check-circle check-icon"></i>
                 </div>
               </div>
            </div>
         </div>
      </div>

      <!-- Tab Content: Filter by Group -->
      <div v-if="activeTab === 'group'" class="tab-content">
         <div v-for="(dealersInGroup, group) in dealersByGroup" :key="group" class="dealer-group">
            <div class="group-header" @click="toggleCollapse('group', group)">
               <span>
                 {{ group || 'Unassigned' }}
                 <small style="font-weight: normal; margin-left: 10px; color: #555;">
                   Total Dealer Count: {{ dealersInGroup.length }} | Selected Dealer Count: {{ getSelectedCount(dealersInGroup) }}
                 </small>
               </span>
               <div class="accordion-actions">
                 <button 
                   class="apply-all-btn" 
                   :class="{ 'remove-btn': getSelectedCount(dealersInGroup) > 0 }"
                   @click.stop="toggleAllDealers(dealersInGroup)">
                   {{ getSelectedCount(dealersInGroup) > 0 ? 'Remove All' : 'Apply All' }}
                 </button>
                 <i :class="getCollapseIcon('group', group)"></i>
               </div>
            </div>
            <div class="group-body" v-show="!isCollapsed('group', group)">
               <div class="dealer-cards">
                 <div v-for="dealer in dealersInGroup" :key="dealer.profileId" 
                      class="dealer-card" 
                      :class="{ selected: isDealerSelected(dealer) }"
                      @click="toggleDealerSelection(dealer)">
                     <strong>{{ dealer.businessName }}</strong><br>
                     <small>Address: {{ dealer.address }}</small><br>
                     <i v-if="isDealerSelected(dealer)" class="fa-solid fa-check-circle check-icon"></i>
                 </div>
               </div>
            </div>
         </div>
      </div>

      <!-- Tab Content: Filter by Category -->
      <div v-if="activeTab === 'category'" class="tab-content">
         <div v-for="(dealersInCategory, category) in dealersByCategory" :key="category" class="dealer-group">
            <div class="group-header" @click="toggleCollapse('category', category)">
               <span>
                 {{ category || 'Unassigned' }}
                 <small style="font-weight: normal; margin-left: 10px; color: #555;">
                   Total Dealer Count: {{ dealersInCategory.length }} | Selected Dealer Count: {{ getSelectedCount(dealersInCategory) }}
                 </small>
               </span>
               <div class="accordion-actions">
                 <button 
                   class="apply-all-btn" 
                   :class="{ 'remove-btn': getSelectedCount(dealersInCategory) > 0 }"
                   @click.stop="toggleAllDealers(dealersInCategory)">
                   {{ getSelectedCount(dealersInCategory) > 0 ? 'Remove All' : 'Apply All' }}
                 </button>
                 <i :class="getCollapseIcon('category', category)"></i>
               </div>
            </div>
            <div class="group-body" v-show="!isCollapsed('category', category)">
               <div class="dealer-cards">
                 <div v-for="dealer in dealersInCategory" :key="dealer.profileId" 
                      class="dealer-card" 
                      :class="{ selected: isDealerSelected(dealer) }"
                      @click="toggleDealerSelection(dealer)">
                     <strong>{{ dealer.businessName }}</strong><br>
                     <small>Address: {{ dealer.address }}</small><br>
                     <i v-if="isDealerSelected(dealer)" class="fa-solid fa-check-circle check-icon"></i>
                 </div>
               </div>
            </div>
         </div>
      </div>
      </template>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
      <button @click="resetForm()">Cancel</button>
      <button @click="createPromotion()" :disabled="loading">
            <span v-if="loading">
              <span class="spinner"></span> Processing...
            </span>
        <span v-else>
              Save Promotion
            </span>
      </button>
    </div>

    <!-- Conflict Modal -->
    <PromotionConflictModal
      v-if="showConflictModal"
      :message="conflictMessage"
      :conflicts="conflictData"
      @close="showConflictModal = false"
    />
  </div>
</template>

<script>
import { getPromotionItemsList, getAllDealers, savePromotion } from "@/services/dataService";
import { useToast } from "vue-toastification";
import PromotionConflictModal from "@/pages/Modal/PromotionConflictModal.vue";

export default {
  components: {
    PromotionConflictModal
  },

  data() {
    return {
      showConflictModal: false,
      conflictMessage: "",
      conflictData: [],
      token: localStorage.getItem('token_set'), //Get the API access token from the local storage
      companyId: localStorage.getItem('company_id'), //Get the logged user's company Id
      profileId: localStorage.getItem('profile_id'), //Get the logged user profileId from the local storage
      reportingProfileId: localStorage.getItem("reportingL1ProfileId"),
      userCategory: localStorage.getItem("user_label"),
      today: new Date().toISOString().split('T')[0],
      loading: false,
      loadingDealers: false,
      items: [],
      dealerSearch: "",
      dealers: [],
      promotion: {
        name: "",
        code: "",
        type: "",
        startDate: "",
        endDate: "",
        freeIssue: {
          getItem: "",
          getQty: "",
          freeItem: "",
          freeQty: "",
          maxQty: ""
        },
        discount: {
          item: "",
          type: "",
          discount: "",
          minQty: "",
          maxQty: ""
        },
        selectedDealers: [],
      },
      activeTab: 'all',
      collapseState: {
        route: {},
        group: {},
        category: {}
      }
    };
  },

  computed: {
    filteredAllDealers() {
      if (!this.dealerSearch) return this.dealers;

      const searchLower = this.dealerSearch.toLowerCase();

      return this.dealers.filter(d => {
        const businessName = d.businessName ? d.businessName.toLowerCase() : "";
        return businessName.includes(searchLower);
      });
    },
    dealersByRoute() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.route || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    },
    dealersByGroup() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.dealer_group || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    },
    dealersByCategory() {
      return this.filteredAllDealers.reduce((acc, dealer) => {
        const key = dealer.dealer_category || 'Unassigned';
        if (!acc[key]) acc[key] = [];
        acc[key].push(dealer);
        return acc;
      }, {});
    },
    filteredItems() {
      if (this.promotion.type === 'Trust') {
        return this.items.filter(item => item.item_cat != null && String(item.item_cat) === '1');
      }
      return this.items;
    }
  },

  watch: {
    'promotion.type'(newType) {
      if (newType === 'Competitor Price Discount') {
        this.promotion.discount.type = 'value';
      }
    }
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  mounted() {
    this.fetchItemVariantList();
    this.fetchDealersList();
  },

  methods: {
    // Get selected count for a given dealer list
    getSelectedCount(dealersList) {
      if (!dealersList || dealersList.length === 0) return 0;
      return dealersList.filter(d => this.isDealerSelected(d)).length;
    },

    //Fetch item variants list from API
    async fetchItemVariantList() {
      try{
        //Reset List before fetch data
        this.items = [];

        //Call API to fetch data
        const response = await getPromotionItemsList(this.companyId, this.token);
        if (response.data.status === true) {
          this.items = response.data.data.map(item => ({
            id: item.id,
            name: item.variant_name.toUpperCase(),
            item_cat: item.item_cat
          }));
        } else {
          this.toast.error(response.data.message);
        }
      } catch (e) {
        this.toast.error("Failed to fetch items list.");
      }
    },

    //Fetch dealers list from API
    async fetchDealersList() {
      try{
        this.loadingDealers = true;
        //Reset List before fetch data
        this.dealers = [];

        let idToUse = this.profileId;
        if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
          idToUse = this.reportingProfileId;
        }

        //Call API to fetch data
        const response = await getAllDealers(this.token, idToUse);
        if (response.data.status === true) {
          this.dealers = response.data.data.map(dealer => ({
            profileId: dealer.profileId,
            businessName: dealer.businessName,
            address: dealer.address,
            distributor: dealer.distributorName,
            district: dealer.district,
            route: dealer.route,
            dealer_group: dealer.dealer_group,
            dealer_category: dealer.dealer_category,
          }));
        } else {
          this.toast.error(response.data.message);
        }
      } catch (e) {
        this.toast.error("Failed to fetch dealers list.");
      } finally {
        this.loadingDealers = false;
      }
    },

    isDealerSelected(dealer) {
      return this.promotion.selectedDealers.some(d => d.profileId === dealer.profileId);
    },

    toggleDealerSelection(dealer) {
      if (this.isDealerSelected(dealer)) {
        this.promotion.selectedDealers = this.promotion.selectedDealers.filter(
            d => d.profileId !== dealer.profileId
        );
      } else {
        this.promotion.selectedDealers.push(dealer);
      }
    },

    toggleAllDealers(dealersList) {
      if (this.getSelectedCount(dealersList) > 0) {
        // Remove all
        const idsToRemove = dealersList.map(d => d.profileId);
        this.promotion.selectedDealers = this.promotion.selectedDealers.filter(
            d => !idsToRemove.includes(d.profileId)
        );
        this.toast?.info(`Removed ${dealersList.length} dealers.`);
      } else {
        // Apply all (only those not already applied)
        const newDealers = dealersList.filter(
            d => !this.isDealerSelected(d)
        );
        if (newDealers.length > 0) {
          this.promotion.selectedDealers.push(...newDealers);
          this.toast?.success(`Applied promotion to ${newDealers.length} dealers!`);
        }
      }
    },

    toggleCollapse(type, key) {
      if (this.collapseState[type][key] === undefined) {
        this.collapseState[type][key] = false;
      }
      this.collapseState[type][key] = !this.collapseState[type][key];
    },

    isCollapsed(type, key) {
      return !!this.collapseState[type][key];
    },

    getCollapseIcon(type, key) {
      return this.isCollapsed(type, key) ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up';
    },

    //Apply All Dealers or Remove Applied Dealers
    toggleDealers() {
      if (this.promotion.selectedDealers.length > 0) {
        // Remove all
        this.promotion.selectedDealers = [];
        this.toast?.info("All dealers removed");
      } else {
        // Apply all
        const existingIds = this.promotion.selectedDealers.map(d => d.profileId);
        const newDealers = this.dealers.filter(d => !existingIds.includes(d.profileId));
        this.promotion.selectedDealers.push(...newDealers);
        this.toast?.success("Applied promotion to all dealers!");
      }
    },

    //Reset form
    resetForm() {
      this.promotion = {
        name: "",
        code: "",
        type: "",
        startDate: "",
        endDate: "",
        freeIssue: {
          getItem: "",
          getQty: "",
          freeItem: "",
          freeQty: "",
          maxQty: ""
        },
        discount: {
          item: "",
          type: "",
          discount: "",
          minQty: "",
          maxQty: ""
        },
        selectedDealers: [],
      };
      this.dealerSearch = "";
    },

    //Form Validations
    validateForm() {
      if (!this.promotion.name) {
        this.toast.error("Promotion name is required");
        return false;
      }
      if (!this.promotion.code) {
        this.toast.error("Promotion code is required");
        return false;
      }
      if (!this.promotion.type) {
        this.toast.error("Promotion type is required");
        return false;
      }
      if (!this.promotion.startDate) {
        this.toast.error("Promotion start date is required");
        return false;
      }
      if (!this.promotion.endDate) {
        this.toast.error("Promotion end date is required");
        return false;
      }

      // End date should not be earlier than start date
      const start = new Date(this.promotion.startDate);
      const end = new Date(this.promotion.endDate);
      if (end < start) {
        this.toast.error("End date cannot be earlier than start date");
        return false;
      }

      if (this.promotion.type === "Free Issue") {
        const fi = this.promotion.freeIssue;
        if (!fi.getItem) {
          this.toast.error("Buy item is required");
          return false;
        }
        if (!fi.getQty) {
          this.toast.error("Buy quantity is required");
          return false;
        }
        if (!fi.freeItem) {
          this.toast.error("Free item is required");
          return false;
        }
        if (!fi.freeQty) {
          this.toast.error("Free quantity is required");
          return false;
        }
        if (!fi.maxQty) {
          this.toast.error("Max quantity is required");
          return false;
        }
      }

      if (["Discount", "Competitor Price Discount", "Trust"].includes(this.promotion.type)) {
        const dis = this.promotion.discount;
        if (!dis.item) {
          this.toast.error("Discount item is required");
          return false;
        }
        if (!dis.type && this.promotion.type !== 'Trust') {
          this.toast.error("Discount type is required");
          return false;
        }
        if (!dis.discount) {
          this.toast.error(this.promotion.type === 'Trust' ? "Maximum quantity is required" : "Discount is required");
          return false;
        }
        if (this.promotion.type === "Discount") {
          if (!dis.minQty) {
            this.toast.error("Minimum quantity is required");
            return false;
          }
          if (!dis.maxQty) {
            this.toast.error("Max quantity is required");
            return false;
          }
        }
      }

      if (this.promotion.selectedDealers.length === 0) {
        this.toast.error("At least one dealer must be selected");
        return false;
      }

      return true; // only true if everything is valid
    },

    //Call API to Save Promotion
    async createPromotion() {
      try {
        this.loading = true;

        //Form Validations
        if (!this.validateForm()) return;

        //Build payload
        let payload = {};

        if (this.promotion.type === "Free Issue") {
          payload = {
            promotionName: this.promotion.name,
            promotionType: this.promotion.type,
            promotion_code: this.promotion.code,
            startDate: this.promotion.startDate,
            endDate: this.promotion.endDate,
            getItem: Number(this.promotion.freeIssue.getItem),
            getQty: Number(this.promotion.freeIssue.getQty),
            freeItem: Number(this.promotion.freeIssue.freeItem),
            freeQty: Number(this.promotion.freeIssue.freeQty),
            maxQty: Number(this.promotion.freeIssue.maxQty),
            selectedCustomers: this.promotion.selectedDealers.map(d => Number(d.profileId)),
            created_by: this.profileId
          };
        } else if (["Discount", "Competitor Price Discount", "Trust"].includes(this.promotion.type)) {
          payload = {
            promotionName: this.promotion.name,
            promotionType: this.promotion.type,
            promotion_code: this.promotion.code,
            startDate: this.promotion.startDate,
            endDate: this.promotion.endDate,
            discountItem: Number(this.promotion.discount.item),
            discountType: this.promotion.type === "Trust" ? 'Quantity' : this.promotion.discount.type,
            discountAmount: Number(this.promotion.discount.discount),
            minQtyDiscount: this.promotion.type === "Discount" ? Number(this.promotion.discount.minQty) : null,
            maxQtyDiscount: this.promotion.type === "Discount" ? Number(this.promotion.discount.maxQty) : null,
            selectedCustomers: this.promotion.selectedDealers.map(d => Number(d.profileId)),
            created_by: this.profileId
          };
        }

        //Call API
        const response = await savePromotion(this.token, payload);

        if (response.data.status === true) {
          this.toast.success(response.data.message);
          this.$router.push('/promotions');
        } else if (response.data.status === "conflict" || response.data.error_code === "PROMOTION_OVERLAP") {
          this.conflictMessage = response.data.message;
          this.conflictData = response.data.conflicts || [];
          this.showConflictModal = true;
        } else {
          // fallback if status is false but not thrown
          this.toast.error(response.data.message || "Something went wrong.");
        }
      } catch (e) {
        // Handle 4xx / 5xx API errors here
        if (e.response && e.response.data) {
          const res = e.response.data;

          if (res.status === "conflict" || res.error_code === "PROMOTION_OVERLAP") {
            this.conflictMessage = res.message;
            this.conflictData = res.conflicts || [];
            this.showConflictModal = true;
          } else if (res.data && typeof res.data === "object") {
            // Get first error message
            const firstKey = Object.keys(res.data)[0];
            const firstMessage = res.data[firstKey][0];
            this.toast.error(firstMessage);
          } else if (res.message) {
            this.toast.error(res.message);
          } else {
            this.toast.error("Something went wrong while saving promotion.");
          }
        } else {
          this.toast.error("Network error, please try again.");
        }
      } finally {
        this.loading = false;
      }
    },

  }
};
</script>

<style scoped>
/* Ensure the body and html take the full height of the page */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0; /* Background color for the page */
}

/* Container for the entire section */
.container {
  background-color: #ffffff;
  padding: 20px 15px; /* reduce side padding for smaller devices */
  margin: 10px auto;
  width: 100%; /* full width of device */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box; /* include padding in width */
  max-width: 100%; /* prevent any fixed max-width */
}

/* Promotion Creation Form - Row */
.form-row {
  display: flex;
  gap: 15px;
}

/* Promotion Creation Form - Group */
.form-group {
  display: flex;
  flex-direction: column;
}

/* Promotion Creation Form - Label */
.form-group label {
  margin-bottom: 5px;
  font-weight: bold;
}

/* Promotion Creation Form - Input/Selection */
.form-group input,
.form-group select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* Promotion Creation Form - Promotion Name Textbox */
.full {
  flex: 1 1 100%;
}

/* Promotion Creation Form - Promotion Type/Item Textbox */
.narrow, .half{
  flex: 1; /* 25% */
}

/* Promotion Creation Form - Item Adding Box Style */
.promo-box {
  border: 1px dashed #ccc;
  padding: 15px;
  margin: 10px 0;
  border-radius: 8px;
  background-color: #f8faff;
}

/* Styling for date-picker */
input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
}

/* Styling for text box */
input[type="text"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
}

/* Styling for text box */
input[type="number"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
}

/* Styling for dropdown */
select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  height: 40px;
}

/* Styling for promotion item setup */
.promotion-item-setup {
  margin-bottom: 20px;
}

/* Styling for promotion item setup warning */
.warning {
  text-align: center;
}
.warning i {
  font-size: 30px;
  color: grey;
  padding-top: 12px;
}
.warning p {
  text-transform: uppercase;
  color: grey;
  font-weight: bold;
}

/* Styling for promotion applicable dealer selection - mandatory indicator */
.dealer-selection-section span {
  color: red;
}

/* Dealer header row (title + count) */
.dealer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

/* Dealer count styling */
.dealer-count {
  font-size: 13px;
  color: grey;
}

/* Make the parent relative so search-results can be positioned absolutely */
.search-container {
  position: relative;
  width: 100%;
  margin-top: 5px;
}

/* Search Box */
.search-box {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 16px;
}

/* Dealer Toggle Button - Apply/Remove */
.dealer-toggle-btn {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  border-radius: 20px;
  padding: 5px 20px;
  font-size: 12px;
  cursor: pointer;
  z-index: 2;
  color: #fff;
}

/* Apply Promotion to All Button */
.apply-btn {
  background-color: #000;
}

/* Apply Promotion to All Button - Mouse Hover */
.apply-btn:hover {
  background-color: #333;
}

/* Remove Dealers Button */
.remove-btn {
  background-color: #dc3545;
}

/* Remove Dealers Button - Mouse Hover */
.remove-btn:hover {
  background-color: #bb2d3b;
}

/* Dealer Tabs */
.dealer-tabs {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}
.dealer-tabs button {
  padding: 8px 20px;
  border: 1px solid #dee2e6;
  background: #f8f9fa;
  cursor: pointer;
  font-weight: 500;
  color: #555;
  border-radius: 25px;
  transition: all 0.2s ease;
}
.dealer-tabs button.active {
  background: #0d6efd;
  border-color: #0d6efd;
  color: white;
}
.dealer-tabs button:hover:not(.active) {
  background: #e9ecef;
}

/* Tab Content */
.tab-content {
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
}

/* Dealer Cards Container */
.dealer-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

/* Dealer Card */
.dealer-card {
  width: calc(33.333% - 10px);
  min-width: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  background: #fff;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.dealer-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-color: #0d6efd;
}
.dealer-card.selected {
  border: 2px solid #0d6efd;
  background: #f0f8ff;
}
.dealer-card .check-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #0d6efd;
  font-size: 18px;
}

/* Dealer Group inside Tabs */
.dealer-group {
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 10px;
  background: #f9f9f9;
}
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eee;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;
}
.group-header span {
  font-size: 14px;
  color: #000;
}
.accordion-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}
.apply-all-btn {
  background: #000;
  color: #fff;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  border: none;
  font-weight: normal;
}
.apply-all-btn:hover {
  background: #333;
}
.apply-all-btn.remove-btn {
  background-color: #dc3545;
}
.apply-all-btn.remove-btn:hover {
  background-color: #bb2d3b;
}
.group-body {
  padding: 15px;
}

/* Promotion Creation Form - Form Actions (Save/Cancel */
.form-actions {
  margin-top: 40px;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Promotion Creation Form - Form Actions Buttons */
.form-actions button {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

/* Promotion Creation Form - Form Actions Button - Cancel */
.form-actions button:first-child {
  background-color: #ccc;
}

/* Promotion Creation Form - Form Actions Button - Save */
.form-actions button:last-child {
  background-color: #0d6efd;
  color: #fff;
}

/* Circular Progress Indicator Styles */
.spinner {
  border: 3px solid #f3f3f3; /* Light gray */
  border-top: 3px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

/* Circular Progress Indicator Styles - Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>